import { get, post } from "../../network/endpoint";
import { dispatchHandler } from "../../utils/action";
import * as ActionTypes from "../action-types";
import { BFF } from "../../network/routes";

export function getInvoiceValue(invoiceId, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: { invoiceId },
      useMock: false,
      client: BFF,
    };
    const request = get("getInvoiceValue", config);

    return dispatch({
      type: ActionTypes.GET_INVOICE_VALUE,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function getInterestFines(invoiceId, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: { invoiceId },
      useMock: false,
      client: BFF,
    };
    const request = get("getInterestFines", config);

    return dispatch({
      type: ActionTypes.GET_INTEREST_FINES,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function getReadjustmentIgp(invoiceId, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: { invoiceId },
      useMock: false,
      client: BFF,
    };
    const request = get("getReadjustmentIgp", config);

    return dispatch({
      type: ActionTypes.GET_READJUSTMENT_IGP,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function getReadjustmentAnatel(invoiceId, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: { invoiceId },
      useMock: false,
      client: BFF,
    };
    const request = get("getReadjustmentAnatel", config);

    return dispatch({
      type: ActionTypes.GET_READJUSTMENT_ANATEL,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function getCancellationValue(invoiceId, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: { invoiceId },
      useMock: false,
      client: BFF,
    };
    const request = get("getCancellationValue", config);

    return dispatch({
      type: ActionTypes.GET_CANCELLATION_VALUE,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function getNrcValue(invoiceId, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: { invoiceId },
      useMock: false,
      client: BFF,
    };
    const request = get("getNrcValue", config);

    return dispatch({
      type: ActionTypes.GET_NRC_VALUE,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function getAdjustment(invoiceId, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: { invoiceId },
      useMock: false,
      client: BFF,
    };
    const request = get("getAdjustment", config);

    return dispatch({
      type: ActionTypes.GET_ADJUSTMENT,
      payload: request,
    }).then(dispatchHandler(callback, callbackFail));
  };
}

export function sendFileAndSaveInvoiceDisputing(data, file, callback) {
  const customerId = data.customerId;
  const renamedFile = new File([file], file.name.replace(/[^.\w\s]/gi, ""), {
    type: file.type,
    lastModified: file.lastModified,
  });

  const formData = new FormData();
  formData.append("file", renamedFile);

  console.log("formData", formData);
  return (dispatch) => {
    const config = {
      pathValues: { customerId },
      data: formData,
      useMock: false,
      client: BFF,
    };
    const request = post("sendInvoiceDisputingFile", config);

    return dispatch({
      type: ActionTypes.SEND_INVOICE_DISPUTING_FILE,
      payload: request,
    })
      .then((response) => {
        let status;

        if (response.type === ActionTypes.SEND_INVOICE_DISPUTING_FILE_FAIL) {
          status = "ERROR";
        } else {
          status = "SUCCESS";
        }

        if (!!response && !!response.payload && !!response.payload.data) {
          let fileId = "";

          fileId = response.payload.data.attachmentView.id;
          data = { ...data, fileId };

          dispatch(invoiceDisputing(data, callback));
        }

        if (
          !!response &&
          !!response.error.response &&
          !!response.error.response.data
        ) {
          return callback && callback(response.error.response.data, status);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };
}

export function invoiceDisputing(data, callback) {
  return (dispatch) => {
    const config = {
      data,
      useMock: false,
      client: BFF,
    };
    const request = post("invoiceDisputing", config);

    return dispatch({
      type: ActionTypes.SAVE_INVOICE_DISPUTING,
      payload: request,
    })
      .then((response) => {
        let status;

        if (response.type === ActionTypes.SAVE_INVOICE_DISPUTING_FAIL) {
          status = "ERROR";
        } else {
          status = "SUCCESS";
        }

        if (!!response && !!response.payload && !!response.payload.data) {
          return callback && callback(response.payload.data, status);
        }

        if (
          !!response &&
          !!response.error.response &&
          !!response.error.response.data
        ) {
          return callback && callback(response.error.response.data, status);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };
}

export function saveInvoiceDisputing(data, file, callback) {
  return (dispatch) => {
    if (!!file) {
      dispatch(sendFileAndSaveInvoiceDisputing(data, file, callback));
    } else {
      dispatch(invoiceDisputing(data, callback));
    }
  };
}



// WEBPACK FOOTER //
// ./src/services/state/invoiceDisputing/action.js